import {Component} from '@angular/core';

@Component({
    selector: 'span-gentle',
    templateUrl: './span-gentle.component.html',
})
export class SpanGentleComponent {

}
